import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck } from 'lucide-react';
export function AudienceSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-8">
      <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-10 lg:mb-12" data-id="element-9">
        Who this is for
      </h2>

      <div className="bg-[#F0F7F2] p-8 lg:p-10 rounded-xl border border-[#1B6B3A]/20" data-id="element-10">
        <p className="text-sm lg:text-base font-medium text-[#1B6B3A] mb-6 lg:mb-8 uppercase tracking-wide" data-id="element-11">
          This is for buyers who:
        </p>

        <ul className="space-y-5 lg:space-y-6" data-id="element-12">
          {['Are closing soon (or already under contract)', "Are tight on cash and can't absorb surprises", 'Want to feel in control without learning mortgage math', 'Want professionals to give clear answers earlier'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-13">
              <div className="bg-[#1B6B3A] rounded-full p-1 mt-1 flex-shrink-0" data-id="element-14">
                <UserCheck className="w-4 h-4 text-white" data-id="element-15" />
              </div>
              <span className="text-lg lg:text-xl text-[#3D3D3D]" data-id="element-16">{item}</span>
            </li>)}
        </ul>
      </div>
    </motion.section>;
}